import { styled } from 'styled-components';

import { StyledNativeLinkWithRef } from '#/components/Link/StyledNativeLinkWithRef';
import {
  colors,
  cssBreakpoints,
  fontWeights,
  gutterWidth,
  maxWidth,
} from '#/theme/theme';

export const ViewUserProfilePageCoverHolder = styled.div`
  width: 100%;
  max-width: 1440px;
  aspect-ratio: 1440 / 280;
  margin: 0 auto;
  position: relative;
`;

export const ViewUserProfilePageCoverHolderBlur = styled.div`
  position: absolute;
  left: 0;
  bottom: 78px;
  width: 1496px;
  max-width: 100%;
  aspect-ratio: 1440 / 280;
  filter: blur(50px);

  @media all and (width <= 1440px) {
    display: none;
  }
`;

export const ViewUserProfilePageCoverHolderForeground = styled.div`
  position: relative;
  z-index: 2;
  height: 100%;

  @media all and (width >= 1441px) {
    img {
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;
    }
  }
`;

export const ViewUserProfilePageContentContainer = styled.div`
  display: flex;
  padding-left: ${gutterWidth / 2}px;
  padding-right: ${gutterWidth / 2}px;
  max-width: ${maxWidth[3]}px;
  margin: 0 auto;
  position: relative;
  z-index: 2;

  @media (min-width: ${cssBreakpoints.mdUp}) {
    gap: 96px;
  }

  @media (max-width: ${cssBreakpoints.mdDown}) {
    flex-direction: column;
    gap: 22px;
  }
`;

export const ViewUserProfilePageContentSidebar = styled.aside`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  z-index: 2;

  @media (max-width: ${cssBreakpoints.xsDown}) {
    margin-top: -48px;
  }

  @media (min-width: ${cssBreakpoints.xsUp}) and (max-width: ${cssBreakpoints.smDown}) {
    margin-top: -60px;
  }

  @media (min-width: ${cssBreakpoints.smUp}) and (max-width: ${cssBreakpoints.mdDown}) {
    margin-top: -92px;
  }

  @media (min-width: ${cssBreakpoints.mdUp}) {
    width: 305px;
    margin-top: -60px;
  }
`;

export const ViewUserProfilePageContentSidebarTitle = styled.h1`
  font-size: 24px;
  margin-top: 12px;
  margin-bottom: 0;
  font-weight: ${fontWeights.semiBold};
`;

export const ViewUserProfilePageContentSidebarLocation = styled.div`
  font-size: 20px;
  margin-top: 16px;
`;

export const ViewUserProfilePageContentSidebarUsername = styled.div`
  font-size: 20px;
  font-style: italic;
  margin-top: 4px;
`;

export const ViewUserProfilePageContentSidebarFollow = styled.div`
  margin-top: 16px;
`;

export const ViewUserProfilePageContentCenter = styled.div`
  position: relative;
  flex: 1;
  display: flex;
  flex-direction: column;
  padding-top: 30px;
`;

export const ViewUserProfilePageContentCenterDetailsLink = styled(
  StyledNativeLinkWithRef,
)`
  color: inherit;
  font-weight: normal;
`;

// Note: The margin correction leaves 84px between the absolute value of the top and the bottom
// which is the height of the action buttons row.
export const ViewUserProfileContentActionButtonsContainer = styled.div`
  @media (max-width: ${cssBreakpoints.mdDown}) {
    margin-top: -254px;
    margin-bottom: 170px;
  }

  @media (max-width: ${cssBreakpoints.smDown}) {
    margin-top: -284px;
    margin-bottom: 200px;
  }

  @media (max-width: ${cssBreakpoints.xsDown}) {
    margin-top: -296px;
    margin-bottom: 212px;
  }
`;

export const ViewUserProfileContentActionButtons = styled.div`
  display: flex;
  flex-direction: row-reverse;
  position: relative;
`;

export const ViewUserProfilePageBlockedBanner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  background-color: ${colors.calloutGrey};
  border-radius: 8px;
  text-align: center;
  margin: ${gutterWidth}px;
  padding: ${gutterWidth}px;

  @media (max-width: ${cssBreakpoints.smDown}) {
    margin: 0;
  }
`;
